import { createUseStorageState } from '../createUseStorageState';
var useSessionStorageState = createUseStorageState(typeof window === 'object' ? window.sessionStorage : null);
export default useSessionStorageState;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useSessionStorageState/index.js
// module id = 7508
// module chunks = 2